import Vue from 'vue'

const actions = {
    getCompaniesFromApi: ({commit}, ApiClient) => {
        ApiClient.Company.getCompanies().then(res => {
            if (res.status === 200) {
                commit('setCompanies', res.data)
            }
        }).catch(err => {
            return err
        });
    },
    getUsers: ({commit}, payload) => {
            return payload.ApiClient.Company.getUsers(payload.companyID).then(res => {
                if (res.status === 200) {
                    commit('setUsersForCompany', res.data)
                }
                return res.data
            }).catch(err => {
                return err
            });

    },
}
export default actions